import { lazy } from "react";
import Loadable from "app/components/Loadable";


const GymProfile = Loadable(lazy(()=>import("./manageGym/GymProfile")))
const PasswordChangeVender = Loadable(lazy(() => import("./PasswordChange")));



const VenderPass = Loadable(lazy(()=>import('./manageGym/passSatting/VenderPass')))

// const ClassSettings = Loadable(lazy(()=>import('./manageGym/classSatting/ClassSettings')))
const WaiverManagement = Loadable(lazy(()=>import('./manageGym/WaiverMang')))

const CustomerFeedback = Loadable(lazy(()=> import('./customer-feedback/Ratting')))

 const AdminAccess = Loadable(lazy(()=> import('./account-settings/Admin-Access')))
 const ContactUs = Loadable(lazy(()=> import('./support-us/contact-us/Contact-us')))
 const Bookings = Loadable(lazy(()=> import('./bookings/Bookings')))
//  const NotificationSettings = Loadable(lazy(()=>import('./account-settings/Notification-settings')))
 const ProfilePage = Loadable(lazy(()=>import('./ProfilePage')))


 const CheckIn = Loadable(lazy(()=>import('./sub-Vender/CheckIn')))
//  const CheckPassCode = Loadable(lazy(()=>import('./sub-Vender/CheckPassCode')))
 const AddSubVender = Loadable(lazy(()=>import('./sub-Vender/AddSubVender')))
 const SubVender = Loadable(lazy(()=>import('./sub-Vender/SubVender')))
 const EditSubVender = Loadable(lazy(()=>import('./sub-Vender/EditSV')))

 const AddFilter = Loadable(lazy(()=>(import('./sub-Vender/AddFilter'))))

 const Setting = Loadable(lazy(()=>import('./setting/setting')))

const materialRoutes = [
  
  { path: "/partner-password-change", element: <PasswordChangeVender /> },
  { path: "/gymProfile", element: <GymProfile /> },
  
  //  { path: "/passSettings", element: <PassSettings /> },
   { path: "/venderPass", element: <VenderPass /> },

   { path: "/customerFeedback", element: <CustomerFeedback /> },
   
   {path:"/WaiverManagement", element:<WaiverManagement />},
   { path: "/admin-access", element: <AdminAccess /> },
   { path: "/contact-us", element: <ContactUs /> },
  { path: "/bookings", element: <Bookings /> },
  //  { path: "/natification-accesses", element: <NotificationSettings /> },
   { path: "/profilePage", element: <ProfilePage /> },
   { path: "/checkin", element: <CheckIn /> },
  //  { path: "/checkPassCode", element: <CheckPassCode />},
   { path: "/add-team-member", element: <AddSubVender />},
   { path: "/member-dashboard", element: <SubVender />},
   { path: "/edit-team-member/:id", element: <EditSubVender />},
   { path: "/add-filter", element: <AddFilter />},
   { path: "/partner-settings", element: <Setting />},
  ];

export default materialRoutes;
